<template>
  <div>
    <v-card width="6000">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          Custom Views
        </DialogTitle>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="10"
          :footer-props="{
            'show-first-last-page': true
          }"
          :headers="headers"
          :items="infoList"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.IsPrivate="{ item }">
            <v-icon v-if="item.IsPrivate" color="secondary">
              {{ icon.lineItemIsChecked }}
            </v-icon>
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-icon small class="mr-2" @click="editItemClick(item)">
              {{ icon.lineItemEdit }}
            </v-icon>
            <v-icon small @click="deleteItemClick(item)">
              {{ icon.lineItemDelete }}
            </v-icon>
          </template>
        </v-data-table>
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="newItemClick">
                <v-icon>{{ icon.lineItemAdd }}</v-icon>
              </v-btn>
            </template>
            <span>New Custom Info</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditorDialog" width="1050" persistent>
      <CustomViewEditor
        :infoId="selectedItemId"
        :isDialogOpen="showEditorDialog"
        @close="editorCloseEvent"
        @update="editorUpdateEvent"
      />
    </v-dialog>

    <DialogUtil ref="dialogUtil" />
  </div>
</template>
<script>
import { ref, watch, computed } from 'vue'
import { host } from '@/services/HostAPI'
import CustomViewEditor from '@/components/Setup/Customer/CustomView/CustomViewEditor'
import { icon } from '@/use/Constants'
export default {
  name: 'CustomViewList',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: { CustomViewEditor },
  setup(props) {
    const dialogUtil = ref(null)
    const loading = ref(false)

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      retrievedInfoList.value = []
      getCustomViewList()
    }

    const retrievedInfoList = ref([])
    const selectedItemId = ref(null)
    const showEditorDialog = ref(false)

    const getCustomViewList = async () => {
      loading.value = true
      const rq = {}
      const rs = await host.customView.list(rq)
      retrievedInfoList.value = rs.InfoList
      loading.value = false
    }

    function editItemClick(item) {
      selectedItemId.value = item.Id
      showEditorDialog.value = true
    }

    function deleteItemClick(item) {
      dialogUtil.value
        .confirm({
          title: 'Please confirm',
          text: `Delete Termination Type ${item.Code}`
        })
        .then(() => performDeleteCustomView(item))
        .catch(() => {
          return
        })
    }

    async function performDeleteCustomView(item) {
      const rq = { InfoId: item.Id }
      const rs = await host.customView.delete(rq)
      if (rs.IsSuccess) {
        getCustomViewList()
      } else {
        dialogUtil.value.error(rs.Message)
      }
    }

    function newItemClick() {
      selectedItemId.value = null
      showEditorDialog.value = true
    }

    const headers = [
      { value: 'Description', text: 'Description', width: 100, align: 'left' },
      { value: 'IsPrivate', text: 'Private', width: 20, align: 'center' },
      { value: 'Actions', text: 'Actions', sortable: false, width: 60 }
    ]

    const infoList = computed(() => {
      return retrievedInfoList.value ? retrievedInfoList.value : null
    })

    const editorCloseEvent = () => {
      showEditorDialog.value = false
    }

    const editorUpdateEvent = () => {
      showEditorDialog.value = false
      getCustomViewList()
    }

    initDialog()

    return {
      dialogUtil,
      infoList,
      headers,
      showEditorDialog,
      selectedItemId,
      editItemClick,
      deleteItemClick,
      newItemClick,
      editorCloseEvent,
      editorUpdateEvent,
      icon,
      loading
    }
  }
}
</script>

<style lang="scss" scoped></style>
